/**
 * 고객(브랜드)의 상태 — 한 곳에서만 정한다. **기능을 쓸 수 있는가는 이 값이 정한다**(구독 행이 아니다 — 261017-brand-status-by-operator).
 *
 *   pending    신청 접수. 데이터 계약을 받지 않는다(승인 대기 화면)
 *   confirmed  **결제 대기** — 보고서·기사가 멈추고 결제 계약만 받는다(「구독 시작」 화면). 첫 결제가 성공하면 active.
 *              새 가입은 승인하면 여기로 온다(261011-subscription-billing-payup). 운영자가 이용 중 브랜드를 여기로 돌릴 수도 있다.
 *              수집은 **이용을 연 적이 있을 때만**(`brand.approved_at`) — 새 가입의 결제 전에는 수집하지 않는다
 *   active     수집·리포트가 열려 있다
 *
 * ★ **계약 종료는 상태가 아니라 삭제(soft, `brand.deleted_at`)다** — 운영자 삭제가 구독 즉시 해지·질문 삭제를 한 트랜잭션으로 하고,
 *   운영자 화면 「삭제된 브랜드」에서 복구한다(261022-brand-delete-is-contract-end). `ended` 상태는 없앴다.
 * ★ 콘텐츠 발행(기사·숏폼·글)의 판정은 이 값이 아니라 **구독**이다 — 「오늘을 덮는 active 구독」(261021-brand-ended-status).
 *
 * ★ 결제가 안 돼도 **active 를 자동으로 내리지 않는다** — 알림(`billing:brand:<id>`)을 보고 운영자가 `setBrandStatus` 로 바꾼다.
 * ★ 수집 게이트는 `activeQuery` 다 — confirmed 를 그냥 넣지 말 것(`approved_at` 조건과 짝이다. 빼면 결제 전에 수집이 시작된다)
 */
export const BRAND_STATUSES = ['pending', 'confirmed', 'active'] as const;
export type BrandStatus = (typeof BRAND_STATUSES)[number];
